import { AppBar, Toolbar, Box, Button, Typography, Menu, MenuItem, Divider, List, IconButton, Drawer } from "@mui/material";
import { loginRequest } from '../authConfig';
import { rutasMenu } from '../routeConfig';
import CustomMenuItem from './menuItem'
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuIcon from "@mui/icons-material/Menu";
import { useState, useEffect } from "react";
import { useUserRolesContext } from '../context/userRolesContext';
import { obtenerParidadUF, obtenerValorUf } from '../features/recaudacionMasiva/archivoPacPat/services/serviceArchivoPac';

const MenuSiscred = () => {

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [valorUF, setValorUF] = useState<number | null>(null);
    const [anchorUfEl, setAnchorUfEl] = useState<null | HTMLElement>(null);
    const openUf = Boolean(anchorUfEl);
    const sinValorUf = valorUF === null || valorUF === 0;

    const handleUfClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorUfEl(event.currentTarget);
    };

    const handleUfClose = () => {
        setAnchorUfEl(null);
    };
    const { instance } = useMsal();
    const { userRoles, isAuthenticated, forceLoadUserData } = useUserRolesContext();

    const fetchValorUF = async () => {
        await obtenerParidadUF();
        
        await new Promise(resolve => setTimeout(resolve, 1000));

        const response = await obtenerValorUf('UF', new Date());
        setValorUF(response.data?.result ?? 0);
    };

      const fetchValorUFInicial = async () => {
        const response = await obtenerValorUf('UF', new Date());
        setValorUF(response.data?.result ?? 0);
    };

    useEffect(() => {
        if (isAuthenticated) {
            fetchValorUFInicial();
        }
    }, [isAuthenticated]);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const url = window.location.origin;

    let activeAccount = instance.getActiveAccount();

    let idTokensClaims;
    if (activeAccount)
        idTokensClaims = activeAccount.idTokenClaims;

    let nombreUsuario: string | undefined;
    if (idTokensClaims)
        nombreUsuario = idTokensClaims["name"]


    const handleLoginPopup = () => {
        instance
            .loginPopup({
                ...loginRequest,
                redirectUri: '/',
            })
            .catch((error) => console.log(error));
    };

    const handleLogoutPopup = () => {
        instance
            .logoutPopup({
                mainWindowRedirectUri: '/',
                account: instance.getActiveAccount(),
            })
            .catch((error) => console.log(error));
    };

    const handleForceLoadRoles = () => {
        console.log('🔧 Botón de prueba: Forzando carga de roles...');
        forceLoadUserData();
    };

    return (

        <>

            <AppBar position="fixed" sx={{ backgroundColor: "#FFFFFF" }}>
                <Toolbar>
                    {/* Contenedor principal */}
                    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>

                        {/* Botón de menú (sólo autenticado) */}
                        <AuthenticatedTemplate>
                            <IconButton sx={{ color: "#000000" }}>
                                <MenuIcon className="toggle-sidebar-btn" sx={{ color: "#000000", cursor: "pointer" }} />
                            </IconButton>
                        </AuthenticatedTemplate>

                        {/* Logo */}
                        <Box component="a" href="#" sx={{ display: "flex", alignItems: "center", textDecoration: "none", ml: 1 }}>
                            <Box sx={{ display: { xs: "none", lg: "block" } }}>
                                <img
                                    src="https://w3.metlife.cl/content/dam/metlifecom/global/icons-header/metlife_logo.png"
                                    width="100"
                                    alt="MetLife Logo"
                                />
                            </Box>
                        </Box>

                        {/* Sistema de Crédito (visible en md en adelante) */}
                        <Box sx={{ flexGrow: 1, textAlign: "center", display: { xs: "none", md: "block" } }}>
                            <Typography sx={{ color: "#000000" }}>Sistema de Crédito</Typography>
                        </Box>

                        {/* Logo alternativo en pantallas pequeñas */}
                        <Box sx={{ display: { xs: "block", md: "none" } }}>
                            <img
                                src="https://w3.metlife.cl/content/dam/metlifecom/global/icons-header/metlife_logo.png"
                                width="110"
                                alt="MetLife Logo"
                            />
                        </Box>

                        {/* Valor UF */}
                        <AuthenticatedTemplate>
                            <>
                                <Box
                                    onClick={sinValorUf ? handleUfClick : undefined}
                                    sx={{
                                        display: { xs: "none", md: "flex" },
                                        alignItems: "center",
                                        gap: 0.75,
                                        backgroundColor: sinValorUf ? "#ffebee" : "#f1f8f1",
                                        border: `1px solid ${sinValorUf ? "#ef9a9a" : "#a5d6a7"}`,
                                        borderRadius: "20px",
                                        px: 1.5,
                                        py: 0.5,
                                        mr: 2,
                                        cursor: sinValorUf ? "pointer" : "default",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: "0.7rem",
                                            fontWeight: 600,
                                            color: sinValorUf ? "#b71c1c" : "#388e3c",
                                            letterSpacing: "0.05em"
                                        }}
                                    >
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: "0.85rem",
                                            color: sinValorUf ? "#c62828" : "#1b5e20",
                                            fontWeight: 500
                                        }}
                                    >
                                        {!sinValorUf
                                            ? `UF $${valorUF.toLocaleString("es-CL")}`
                                            : "UF sin valor"}
                                    </Typography>
                                </Box>

                                <Menu
                                    anchorEl={anchorUfEl}
                                    open={openUf}
                                    onClose={handleUfClose}
                                    anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "right"
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "right"
                                    }}
                                >
                                    <MenuItem
                                        onClick={async () => {
                                            handleUfClose();
                                            await fetchValorUF()
                                        }}
                                    >
                                        <Typography variant="body2">
                                            🔄 Cargar UF
                                        </Typography>
                                    </MenuItem>
                                </Menu>

                            </>
                        </AuthenticatedTemplate>

                        {/* Menú de usuario */}
                        <AuthenticatedTemplate>
                            <Box sx={{ ml: "auto" }}>
                                <IconButton onClick={handleClick} sx={{ color: "#000000" }}>
                                    <AccountCircleIcon />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                                >
                                    <MenuItem disabled>
                                        <Typography variant="subtitle1">{nombreUsuario}</Typography>
                                    </MenuItem>
                                    <MenuItem disabled>
                                        <Typography variant="caption">Roles: {userRoles.length > 0 ? userRoles.join(', ') : 'No cargados'}</Typography>
                                    </MenuItem>
                                    <MenuItem onClick={handleForceLoadRoles}>
                                        <Typography variant="caption">🔧 Cargar Roles (Prueba)</Typography>
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={handleLogoutPopup}>
                                        <ExitToAppIcon sx={{ mr: 1 }} />
                                        <Typography>Cerrar sesión</Typography>
                                    </MenuItem>
                                </Menu>
                            </Box>
                        </AuthenticatedTemplate>

                        {/* Botón de Iniciar sesión (cuando no está autenticado) */}
                        <UnauthenticatedTemplate>
                            <MenuItem onClick={handleLoginPopup}>
                                <Typography variant="body1" sx={{ color: "#000000", fontSize: "1rem" }}>Iniciar sesión</Typography>
                            </MenuItem>
                        </UnauthenticatedTemplate>

                    </Box>
                </Toolbar>
            </AppBar>

            <AuthenticatedTemplate>
                <aside id="sidebar" className="sidebar">
                    <Box sx={{ overflow: "auto" }}>
                        <List>
                            {rutasMenu.map((ruta) => (
                                <CustomMenuItem baseUrl={url} rutaObj={ruta} parentId="sidebar-nav" key={ruta.id} />
                            ))}
                        </List>
                    </Box>
                </aside>
            </AuthenticatedTemplate>
        </>
    )
}

export default MenuSiscred;
